export const MessageModel = {
    id: "",
    user_id: "",
    notify: {
        id: "",
        created_at: null,
        title: "",
        description: "",
        sender: "",
        type: "",
        date_to: null,
        result: "",
        url: "",
        params: {
            ended: true,
            task_id: 0
        }
    },
    read_at: null,
    read: true,
    accept_at: null,
    accepted: false,
    close_at: null,
    closed: false,
    cancel_at: null,
    canceled: false,
    description: null,
    trash: false,
    trash_at: null,
    user: ""
};